import request from '@/utils/request'

// 大屏选项
export function findScreenTypeOptions(params) {
  return request({
    url: `/screen_type/options`,
    method: 'get',
    params: params
  })
}
